import React, { useState, useRef, useEffect } from 'react'
import { useMutation } from 'react-query'
import { exportPricings } from './PricesFunctions'
import { KTSVG } from '../../../_metronic/helpers'

function ExportButton({ accessToken, gateType }) {
  const [successVisible, setSuccessVisible] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const timeoutRef = useRef(null)

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [])

  const exportMutation = useMutation(
    (gateTypeId) => exportPricings(accessToken, gateTypeId),
    {
      onSuccess: () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current)
        setErrorMsg('')
        setSuccessVisible(true)
        timeoutRef.current = setTimeout(() => setSuccessVisible(false), 3000)
      },
      onError: (err) => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current)
        setSuccessVisible(false)
        setErrorMsg(err?.message ?? 'Coś poszło nie tak')
        timeoutRef.current = setTimeout(() => setErrorMsg(''), 4000)
      },
    }
  )

  if (!gateType || gateType === 'nogate') return null

  return (
    <div className="position-relative d-inline-block">
      <button
        onClick={() => exportMutation.mutate(gateType)}
        disabled={exportMutation.isLoading}
        className="btn btn-sm btn-light-primary"
      >
        <KTSVG path="/media/icons/duotune/files/fil009.svg" className="svg-icon-3 me-2" />
        {exportMutation.isLoading ? 'Eksportuję...' : 'Eksportuj cennik'}
      </button>

      <div
        className="position-absolute start-0 w-100 text-center"
        style={{ top: '100%', marginTop: 6, pointerEvents: 'none' }}
        aria-live="polite"
      >
        {successVisible && (
          <span className="badge badge-light-success fw-bold">Eksport zakończony</span>
        )}
        {errorMsg && (
          <span className="badge badge-light-danger fw-bold">{errorMsg}</span>
        )}
      </div>
    </div>
  )
}

export default ExportButton
